// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'va/lib/css'
import 'va/lib/script'

import Vue from 'vue'
import App from './App'
import router from './router'
import EventBus from './lib/eventBus.js'
import axios from 'axios'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import '@/filters'
import 'vue2-datepicker/index.css'
import UUID from 'vue-uuid'
import CurrencyInput from './components/CurrencyInput'

Vue.config.productionTip = false

Vue.use(UUID)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.component('currency-input', CurrencyInput)

const options = {
  latencyThreshold: 200, // Number of ms before progressbar starts showing, default: 100,
  router: true, // Show progressbar when navigating routes, default: true
  http: false // Show progressbar when doing Vue.http, default: true
}
Vue.use(NProgress, options)

Vue.prototype.$bus = EventBus
Vue.prototype.$http = axios

Vue.config.productionTip = false

export const eventBus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js